import type { RootState } from 'APP/Store/CreateStore'

export const selectPlaces = (state: RootState) => state.places.list.data
export const selectPlacesLoading = (state: RootState) => state.places.list.loading
export const selectPlacesError = (state: RootState) => state.places.list.error
